import { Stack } from "@mui/material";
import { ActionField } from "src/api/client-api/ActionPlan/ActionPlanAction/useGetOneActionPlanAction";
import { useMyActionPlanContext } from "src/components/Actions/Tabs/2_TabActionPlan/context/useMyActionPlan";
import { useTranslation } from "react-i18next";
import { ManySubproperty } from "./ManySubproperty";
import { formatMultivalue } from "src/components/Actions/Tabs/2_TabActionPlan/context/utils/formatMultivalue/formatMultivalue";
import { OneSubproperty } from "./OneSubproperty";

type ActionFieldMultivalueProps = {
    fields: ActionField[];
};

export const ActionFieldMultivalue = (props: ActionFieldMultivalueProps) => {
    const { t } = useTranslation();
    const { actionPlanAction, fieldValues, startingPost } = useMyActionPlanContext();
    const { fields } = props;

    const actionPlanActionId = actionPlanAction.id;

    if (actionPlanActionId === undefined) {
        // Not supposed to happen
        return;
    }

    const actionMultivalue = formatMultivalue({
        actionFields: fields,
        actionPlanAction,
        fieldValues,
        getDefaultLabel: (rowIndex) => {
            if (rowIndex === undefined) {
                return t("action_plan.line", "Line");
            }
            return t("action_plan.line.position", {
                defaultValue: "Line {{position}}",
                position: rowIndex + 1,
            });
        },
        startingPost,
    });
    const hasOneFieldForMulti = fields.length === 1;

    return (
        <Stack>
            {hasOneFieldForMulti ?
                <OneSubproperty actionMultivalue={actionMultivalue} actionField={fields[0]} />
            :   <ManySubproperty actionMultivalue={actionMultivalue} />}
        </Stack>
    );
};
